import { render, staticRenderFns } from "./OwnersListTableColor.vue?vue&type=template&id=d08d1e3c&scoped=true"
import script from "./OwnersListTableColor.vue?vue&type=script&lang=js"
export * from "./OwnersListTableColor.vue?vue&type=script&lang=js"
import style0 from "./OwnersListTableColor.vue?vue&type=style&index=0&id=d08d1e3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08d1e3c",
  null
  
)

export default component.exports